import { computed, h, unref } from 'vue';
import type { ComputedRef, Slots } from 'vue';
import { getSlot, isString } from '@mts-fe/utils';
import TableHeader from '../components/TableHeader.vue';
import type { BasicTableProps, InnerHandlers, InnerMethods } from '../types/table';

export function useTableHeader(
  propsRef: ComputedRef<BasicTableProps>,
  slots: Slots,
  handlers: InnerHandlers,
  //
  methods: InnerMethods,
) {
  const getHeaderProps = computed((): Recordable => {
    const {
      title,
      showTableSetting,
      titleHelpMessage,
      tableSetting,
      showBatchBar,
      batchBar,
      showSelectionBar,
    } = unref(propsRef);
    const hideTitle = !slots.tableTitle && !title && !slots.toolbar && !showTableSetting;
    if (hideTitle && !isString(title)) {
      return {};
    }

    return {
      title: hideTitle
        ? null
        : () =>
            h(
              TableHeader,
              {
                title,
                titleHelpMessage,
                showTableSetting,
                tableSetting,
                showBatchBar,
                batchBar,
                onColumnsChange: handlers.onColumnsChange,
                //
                clearSelectedRowKeys: methods.clearSelectedRowKeys,
                count: methods.getSelectRowKeys().length,
                total: methods.getDataSource().length,
                showSelectionBar,
              } as Recordable,
              {
                ...(slots.toolbar
                  ? {
                      toolbar: () => getSlot(slots, 'toolbar'),
                    }
                  : {}),
                ...(slots.tableTitle
                  ? {
                      tableTitle: () => getSlot(slots, 'tableTitle'),
                    }
                  : {}),
                ...(slots.headerTop
                  ? {
                      headerTop: () => getSlot(slots, 'headerTop'),
                    }
                  : {}),
                ...(slots.selectionBar
                  ? {
                      selectionBar: (data) => getSlot(slots, 'selectionBar', data),
                    }
                  : {}),
              },
            ),
    };
  });
  return { getHeaderProps };
}
